module.exports = __webpack_public_path__ + "static/media/foto_brahma_05.b0c14b76.jpg";